import { render, staticRenderFns } from "./div-scroll.vue?vue&type=template&id=1ce5ec6e&"
import script from "./div-scroll.vue?vue&type=script&lang=ts&"
export * from "./div-scroll.vue?vue&type=script&lang=ts&"
import style0 from "./div-scroll.vue?vue&type=style&index=0&id=1ce5ec6e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports